import React from "react";
import PropTypes from "prop-types";
import Button from "@visiblethread/react-components/dist/components/Button";

const ActionCard = ({ image, header, description, cta }) => (
  <div className="action_card" data-testid="action-card">
    {image && <div className="action_card__image">{image}</div>}
    <header>{header}</header>
    <span>{description}</span>
    {cta}
  </div>
);

export default ActionCard;

ActionCard.propTypes = {
  image: PropTypes.instanceOf(Element),
  header: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cta: PropTypes.oneOfType([
    PropTypes.instanceOf(Element),
    PropTypes.shape({ current: PropTypes.instanceOf(Button) }),
  ]),
};
